<template>
  <content-dialog
    :visible.sync="modalVisible"
    scrollable
    max-width="500"
  >
    <!--<editor-fold desc="Dialog title">-->
    <template slot="dialogTitle">
      Reject Deal
    </template>
    <!--</editor-fold>-->

    <v-card-text class="pa-6">
      <p>Enter the reason why this deal is being rejected.</p>
      <v-textarea
        v-model="reason"
        v-validate="'required|min:3'"
        outlined
        placeholder="Enter reason"
        data-vv-as="reason"
        name="reason"
        single-line
        :error-messages="veeErrors.collect('reason')"
      />
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        @click="updateYacht"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Reject
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
import Yacht from '@/models/Yacht'
import ContentDialog from '@/components/helpers/Dialog'

export default {
    name: 'RejectDealDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: Boolean,
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        reason: null,
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      yachtDirty: {
        get: function () {
          return this.yacht
        },
        set: function (value) {
          this.$emit('update:yacht', value)
        }
      }
    },
    methods: {
      async updateYacht() {
        let validation = await this.$validator.validateAll()

        if (!validation) return

        this.submitting = true

        try {
          let response = await Yacht.api.rejectDeal(this.yachtDirty.id, this.reason)

          this.yachtDirty = response.yacht
          this.modalVisible = false
          this.$store.dispatch('alert', {
            'text': 'Sales started for selected yacht owner.',
            'color': 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
